exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addManualURLPick label{margin-top:5px;margin-bottom:0}.addManualURLPick .form-control{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/picks/add_manual_url_pick.scss
// module id = 1395
// module chunks = 0